import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import ContentBlocksEditor from '~/javascript/components/admin/content_blocks_editor.vue'

export default class extends Controller {
  static targets = ['hiddenInput', 'jsonFallback']

  static values = {
    blocks: { type: Array, default: []}
  }

  connect() {
    this.mountVueEditor()
  }

  disconnect() {
    this.vue?.unmount()
  }

  mountVueEditor() {
    const mountPoint = this.element.querySelector('[data-vue-mount]')

    // Clear existing mount if remounting
    if (this.vue) {
      this.vue.unmount()
      mountPoint.innerHTML = ''
    }

    const props = {
      initialBlocks: this.blocksValue,
      onUpdate: this.handleUpdate.bind(this)
    }

    this.vue = createApp(ContentBlocksEditor, props)
    this.vue.mount(mountPoint)
  }

  handleUpdate(blocks) {
    // Update the hidden input with the JSON value
    if (this.hasHiddenInputTarget) {
      this.hiddenInputTarget.value = JSON.stringify(blocks)
    }

    // Also update the JSON fallback textarea if it exists
    if (this.hasJsonFallbackTarget) {
      this.jsonFallbackTarget.value = JSON.stringify(blocks, null, 2)
    }
  }

  syncFromJson() {
    if (!this.hasJsonFallbackTarget) return

    try {
      const jsonText = this.jsonFallbackTarget.value
      const blocks = JSON.parse(jsonText)

      if (!Array.isArray(blocks)) {
        alert('Invalid JSON: Must be an array of content blocks')
        return
      }

      // Update the blocks value and remount the Vue editor
      this.blocksValue = blocks

      // Update hidden field
      if (this.hasHiddenInputTarget) {
        this.hiddenInputTarget.value = JSON.stringify(blocks)
      }

      // Remount Vue editor with new blocks
      this.mountVueEditor()

      alert('JSON synced successfully!')
    } catch (e) {
      alert(`Invalid JSON: ${e.message}`)
    }
  }
}
